<ng-container *vsLet="propertySet$ | async as propertySet">
  <ng-container *ngIf="propertySet">
    <div *ngFor="let assignment of propertySet!.properties">
      <vs-property-badge [property]="assignment.property!" [showHidden]="showHidden"></vs-property-badge>
    </div>
  </ng-container>
</ng-container>
